import { render } from "./SystemAdmin11.vue?vue&type=template&id=c42f37e0&scoped=true"
import script from "./SystemAdmin11.vue?vue&type=script&lang=js"
export * from "./SystemAdmin11.vue?vue&type=script&lang=js"

import "./SystemAdmin11.vue?vue&type=style&index=0&id=c42f37e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c42f37e0"]])

export default __exports__